exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody,\nhtml,\napp-root {\n  height: 100vh;\n  margin: 0;\n  padding: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/ReedBenedian/repos/sulzer/gm-hackathon-registration/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/ReedBenedian/repos/sulzer/gm-hackathon-registration/node_modules/postcss-loader?{"ident":"postcss"}!C:/Users/ReedBenedian/repos/sulzer/gm-hackathon-registration/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!C:/Users/ReedBenedian/repos/sulzer/gm-hackathon-registration/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles